export const getLocationByZip = async (zip: string) => {
    return await fetch(`${process.env.GATSBY_CC_GQL_URL}/graphql`, {
        method: 'POST',
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Method': 'POST',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query: `
                query areaByZipCode($zip: String!) {
                    areaByZipCode(zipCode: $zip) {
                        zip
                        locationList {
                            zip
                            ssacd
                            stateAbbr
                            countyName
                            fipsCode
                            cityName
                            stateName
                        }
                        hasError
                        message
                    }
                }
            `,
            variables: { zip },
        }),
    })
        .then(
            (res) =>
                res.json() as Promise<{
                    data: {
                        areaByZipCode: {
                            hasError: boolean | null;
                            locationList: GeoLocation[];
                            message: string | null;
                            zip: string;
                        };
                    };
                }>
        )
        .catch((error) => {
            console.error('Error:', error);
        });
};

export const getLocationByIpAddress = async () => {
    return await fetch(`${process.env.GATSBY_CC_GQL_URL}/graphql`, {
        method: 'POST',
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Method': 'POST',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query: `
                query locationByIpAddress {
                    locationByIpAddress {
                        zip
                        locationList {
                            zip
                            ssacd
                            stateAbbr
                            countyName
                            fipsCode
                            cityName
                            stateName
                        }
                        hasError
                        message
                    }
                }
            `,
        }),
    })
        .then(
            (res) =>
                res.json() as Promise<{
                    data: {
                        locationByIpAddress: {
                            hasError: boolean | null;
                            locationList: GeoLocation[];
                            message: string | null;
                            zip: string;
                        };
                    };
                }>
        )
        .catch((error) => {
            console.error('Error:', error);
        });
};
